export const TRANSLATIONS_JP_HOME_QUALITY_AND_ALERTS = {
  "home.qaHarness.card.formDetail": "フォーム付き詳細",
  "home.qaHarness.card.reevaluationFeedback": "再評価キュー",
  "home.qaHarness.card.inspectionFeedback": "確認のみの結果",
  "home.qaHarness.card.acknowledgedFeedback": "業務アクション受付済み",
  "home.qaHarness.card.manualCompletionFeedback": "手動完了確認済み",
  "home.qaHarness.card.replayFeedback": "リプレイ結果",
  "home.alerts.title": "対応が必要です",
  "home.alerts.viewAll": "すべて表示",
  "home.alerts.empty": "アクティブなアラートはありません。",
  "home.alerts.loading": "読み込み中...",
  "home.alerts.errorMessage": "アラートを読み込めませんでした。",
  "home.alerts.retry": "再試行",
};
